export default "__VITE_ASSET__1fe9da3c__"